import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
const isV3 = allVue.version && allVue.version[0] === '3'
import KendoUploadMixin from './KendoUploadMixin'

export default {
    name: 'kendo-upload',
    mixins: [ KendoUploadMixin ],
    setup() {
        const v3 = isV3
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement

        if(this.v3){
            return h('input',{
                type: 'file'
            })
        } else {
            return h('input',{
                attrs: {
                    type: 'file'
                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-upload-vue-wrapper/src/KendoUpload/index.js